import useResources from "./use-resources";

export default function usePromos() {
  const {
    resources: promos,
    error,
    isLoading,
    create,
  } = useResources("promos");

  return {
    promos,
    error,
    isLoading,
    createPromo: create,
  };
}
